import React, { useContext, useEffect, useState } from 'react';

import { AppContext } from '~/contexts/AppContext';

import styled from 'styled-components';
import { animated, useSpring } from 'react-spring';
import ResultSlide from './ResultSlide';
import { GroupResult } from '~/types';
import GenderResultSlide from './slides/GenderResultSlide';
import { SliderAnimationState } from '../SliderPanel';  
import StaticSlider from '~/components/StaticSlider';

const RatingResultStyle = styled(animated.div)`
    width: calc(100% - 60px);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin: 20px auto;
`;

const ResultContainer = styled.div`
    flex: 1;
    height: calc(100% - 25px);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

interface RatingResultProps {
    ratingValue: number;
    ratingId: number | null;
    sliderAnimationState: SliderAnimationState;
    onAnimationComplete: () => void;
    loadingResults: { [groupString: string]: boolean };
    groupResults: { [groupString: string]: GroupResult };
    setReferenceRating: (referenceRating: number | null, referenceColor: string | null) => void;
    submitGender: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    isFirstSlide?: boolean;
}

interface RatingResultState {
    fadeInComplete: boolean;
}

const GenderResult: React.FC<RatingResultProps> = (props) => {

    const { topicData } = useContext(AppContext)!;

    const [state, setState] = useState<RatingResultState>(() => ({
        fadeInComplete: false,
    }));

    const [resultContainerStyle] = useSpring(() => ({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duation: 600 },
        onRest: () => {
            setState(prevState => ({...prevState, fadeInComplete: true }));
        }
    }));

    useEffect(() => {
        if (props.isFirstSlide) {
            const groupResult: GroupResult | undefined = props.groupResults['gender'];

            if (groupResult)
                props.setReferenceRating(groupResult.rating, groupResult.color);
            else
                props.setReferenceRating(null, null);
        }
    }, [props.groupResults, props.isFirstSlide]);
    
    return (
        <RatingResultStyle style={resultContainerStyle}>
            <div style={{ 
                filter: (!props.groupResults.gender || !props.groupResults.gender.rating) ? 'saturate(0)' : 'none',
                transition: 'filter 0.2s ease'
            }}>
                <StaticSlider 
                    userRating={props.ratingValue}
                    majorityRating={props.groupResults.gender?.rating || null}
                    showReferenceLine={true}
                    referenceLineColor={props.groupResults.gender?.color || '#000000'}
                    hideSlider={props.isFirstSlide}
                />
            </div>
            <ResultContainer>
                {topicData?.topic.pvtShowGenderStats && (
                    <div style={{
                        width: '100%'
                    }}>
                        <ResultSlide 
                            index={0} 
                            loadingResults={props.loadingResults.gender}
                            groupResult={props.groupResults.gender}
                            currentSlide={0} 
                            slideClicked={() => {}}
                        >
                            <GenderResultSlide
                                ratingValue={props.ratingValue}
                                groupResult={props.groupResults.gender}
                                submitGender={props.submitGender}
                                fadeInComplete={state.fadeInComplete}
                                onAnimationComplete={props.onAnimationComplete}
                            />
                        </ResultSlide>
                    </div>
                )}
            </ResultContainer>
        </RatingResultStyle>
    );
};

export default GenderResult;